module.exports = __webpack_public_path__ + "static/media/icon-link.1894543c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-link.svg
// module id = 1462
// module chunks = 0